import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 5px;
  /* padding-left: 45px; */
  width: 268px;
`;
export const CategoryWrapper = styled.div`
  /* margin-top: 64px; */
`;
export const Title = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  color: #151515;
`;
export const CategoryInfoWrapper = styled.div`
  margin-top: 5px;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
export const NameWrapper = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #151515;
  margin-top: 12px;
`;
export const NumberWrapper = styled.div`
  width: 38px;
  height: 18px;
  background: #f4f8ec;
  border-radius: 12px;
  margin-left: auto;
  text-align: center;
  margin-right: 40px;
  margin-top: 12px;
`;
export const BrandWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;
export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${(props) => (props.top ? "5px" : "18px")};
`;
export const CheckBoxInput = styled.input`
  border: 1.5px solid #d1d1d1;
  width: 18px;
  height: 18px;
  margin-right: 10px;
`;
export const CheckBoxLabel = styled.label`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #151515;
  margin-right: auto;
  margin-left: 10px;
`;
export const RatingWrapper = styled.div`
  margin-top: 50px;
`;
export const RatingTitle = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #151515;
`;
export const StarWrapper = styled.div`
  margin-top: 23px;
  display: flex;
  flex-direction: column;
`;
// Price
export const PriceWrapper = styled.div`
  margin-top: 15px;
`;
export const RangeInput = styled.input`
  margin-top: 23px;
  width: 195px;
  height: 6px;
  border-radius: 8px;
`;
export const InputWarpper = styled.div`
  display: flex;
`;
export const MinInputWrapper = styled.div`
  margin-top: 23px;
  display: flex;
  flex-direction: column;
  ${(props) => {
    if (props.maximum) {
      return `
      margin-left: 20px; 
      `;
    } else {
      return `
      margin-left: 0px;
   `;
    }
  }}
`;
export const PriceLabel = styled.label`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #151515;
`;
export const PriceInput = styled.input`
  background: #f9f9f9;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 8px;
  width: 90px;
  height: 42px;
  outline: none;
  padding-left: 20px;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
`;
export const Buttons = styled.button`
  cursor: pointer;
  width: 78px;
  height: 42px;
  background: rgb(126, 211, 33);
  border: 2px solid #46760a;
  box-sizing: border-box;
  border-radius: 12px;
  color: white;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  :active {
    transform: scale(0.95);
    box-shadow: rgb(126, 211, 33) 0px 3px 10px;
  }
  :hover {
    background-color: white; /* Green */
    color: rgb(126, 211, 33);
  }
  border: 1px solid rgb(126, 211, 33);
  border-radius: 8px;
`;

export const ResetInput = styled.input`
  cursor: pointer;
  margin-left: 35px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  color: #a9a9a9;
  border: none;
  background: none;
  :active {
    transform: scale(0.95);
  }
`;
